import React from 'react';

function WinGauge({ value, size = 60, primary = '#3498db', showValue = true }) {
  const strokeWidth = 8;
  const circleSize = 100;
  const radius = circleSize / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  
  // Calculate stroke dash array based on percentage
  const strokePercent = value;
  const strokeDasharray = `${(strokePercent * circumference) / 100} ${circumference}`;
  
  // Determine color based on value
  const getColor = () => {
    if (typeof primary === 'string') {
      return primary;
    }
    return strokePercent <= 33
      ? '#dc2626' // Red
      : strokePercent <= 66
        ? '#f59e0b' // Amber
        : '#22c55e'; // Green
  };
  
  const circleStyles = {
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeDashoffset: 0,
    strokeWidth: strokeWidth,
    transition: 'all 1000ms ease',
    transformOrigin: '50% 50%',
  };

  // Calculer la taille de police proportionnelle à la taille du cercle
  const fontSize = Math.max(size / 3, 14);
  
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox={`0 0 ${circleSize} ${circleSize}`}
      width={size}
      height={size}
      style={{ userSelect: 'none' }}
      fill='none'
    >
      {/* Background circle */}
      <circle
        cx={circleSize / 2}
        cy={circleSize / 2}
        r={radius}
        style={{
          ...circleStyles,
          stroke: '#e0e0e0',
        }}
      />

      {/* Value circle */}
      <circle
        cx={circleSize / 2}
        cy={circleSize / 2}
        r={radius}
        style={{
          ...circleStyles,
          strokeDasharray: strokeDasharray,
          transform: 'rotate(-90deg)',
          transformOrigin: '50% 50%',
          stroke: getColor(),
        }}
      />

      {/* Toujours afficher la valeur, indépendamment du paramètre showValue */}
      <text
        x='50%'
        y='50%'
        textAnchor='middle'
        dominantBaseline='middle'
        fill={getColor()}
        fontSize={fontSize}
        fontWeight="bold"
      >
        {Math.round(strokePercent)}
      </text>
    </svg>
  );
}

export default WinGauge; 